import * as React from 'react';
import { Button, Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import { Link, Navigate } from 'react-router-dom';
import './ImageCardInfo.css';

export default function ImageCardInfo({ para }) {
    return (
        <Box
            
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    maxWidth: {
                        xs: '80vw',
                        sm: '80vw',
                        md: '90vw',
                        lg: '90vw',
                    },
                }}
            >


                <Card
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        //minWidth: '50vw',
                        flexDirection:
                        {
                            xs: 'column',
                            sm: 'column',
                            md: 'column',
                            lg: 'column'
                        },
                        width: {
                            xs: '85%',
                            sm: '80%',
                            md: '50%',
                            lg: '50%',
                        },
                        height: '100%',
                    }}
                >

                    <CardMedia
                        sx={{
                            width: '99%',
                            //maxHeight: '20vh',
                            minHeight: '100%',
                            //margin: '5px',
                            margin: '0.5%',
                            borderRadius: '3px',
                            
                        }}
                        component="img"
                        image={para.pic}
                        //title={para.pde}
                    />
                    <CardContent
                        sx={{
                            
                            display: 'flex',
                            flexDirection: 'column',
                            
                            width: { xs: '100%', sm: '100%', /*md: '50%', lg: '50%'*/ },
                            //height: { xs: '100%', sm: '100%', md: '100%', lg: '100%' },
                            
                            /*
                            old 
                            width: { xs: '100%', sm: '100%', md: '50%', lg: '50%' },
                            height: { xs: '50%', sm: '50%', md: '100%', lg: '100%' },
                            */
                            padding: 0,
                            margin: 0,
                            p: 0,
                            '&:last-child': { pb: 0 },
                        }}
                    >
                        <Typography
                            gutterBottom variant="h5"
                            component="h2"
                            id="header"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                paddingTop: 2,
                                fontSize:
                                {
                                    xs: '6.8vw',
                                    sm: '4.5vw',
                                    md: "2.8vw",
                                    lg: "2.95vw"
                                },
                            }}
                        >
                            Kuvat
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.8vw"
                                },

                            }}
                        >
                            Kiitos paljon osallistujille.
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.8vw"
                                },

                            }}
                        >

                            Hääkuvat löytyvät <a href="https://photos.app.goo.gl/Ui1X3WCvbRd9V8wm6" 
                            target="_blank" rel="noopener noreferrer">tästä</a> linkistä ja alla olevasta painikkeesta.
                            
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'stretch',
                                margin: '1.5vw 1vw 1vw 1vw',
                            }}
                        >
                        <Button
                                    sx={{
                                        width: '100%',
                                        backgroundColor: '#3260a8',
                                    }}
                                    variant="contained"
                                    color="secondary"
                                    href="https://photos.app.goo.gl/Ui1X3WCvbRd9V8wm6"
                                >
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                        component="p"
                                        sx={{
                                            //paddingLeft: 2,
                                            //paddingRight: 2,
                                            color: 'white',
                                            margin: 0,
                                            padding: 0,
                                            fontSize:
                                            {
                                                xs: '5.0vw',
                                                sm: '2.5vw',
                                                md: "1.8vw",
                                                lg: "1.95vw"
                                            },

                                        }}
                                    >
                                        Kuvakansioon
                                    </Typography>
                                </Button>
                                </Box>
                    </CardContent>
                </Card>
            </Box>

        </Box>





    );
}
